export enum PersistencyTypes {
  Backend = 'backend',
  Local = 'local',
}
